import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles((t: typeof theme) => ({
  error: {
    color: t.red01,
  },

  marginTop: {
    marginTop: '1rem',
  },
}))
